import type { ReactNode } from "react";

const noiseTexture = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 120'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='1.3' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='120' height='120' filter='url(%23n)' opacity='0.42'/%3E%3C/svg%3E")`;

export function PrimaryButton({
  onClick,
  disabled,
  fullWidth,
  children,
  type = "button",
}: {
  onClick?: () => void;
  disabled?: boolean;
  fullWidth?: boolean;
  children: ReactNode;
  type?: "button" | "submit";
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`relative overflow-hidden text-white px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-200 border disabled:opacity-40${fullWidth ? " w-full mt-3" : ""}`}
      style={{ backgroundColor: "#111111", borderColor: "rgba(0,0,0,0.08)" }}
      onMouseEnter={(e) => {
        if (!e.currentTarget.disabled) {
          e.currentTarget.style.backgroundColor = "#333333";
          e.currentTarget.style.transform = "scale(1.02)";
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "#111111";
        e.currentTarget.style.transform = "scale(1)";
      }}
    >
      <span
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: `linear-gradient(130deg, rgba(255,255,255,0.38) 0%, rgba(255,255,255,0.14) 45%, rgba(255,255,255,0.32) 100%), ${noiseTexture}`,
          backgroundSize: "100% 100%, 120px 120px",
          backgroundRepeat: "no-repeat, repeat",
          mixBlendMode: "overlay",
          opacity: 0.92,
        }}
      />
      <span className="relative">{children}</span>
    </button>
  );
}
